@import "@/styles/variables";

.productOptionTable {
	width: 100%;
	border: 1px solid #e5e5e5;
	border-radius: 4px;
	background: white;
}

.productOptionHeader {
	color: $gray-700;
	border-bottom: 1px solid $gray-100;
	padding: 8px 12px;
	font-weight: 600;
	font-size: 12px;

	display: grid;
	grid-template-columns: 4fr 3fr 1fr;

	span:last-child {
		text-align: right;
	}
}

.productOptionRow {
	display: grid;
	grid-template-columns: 4fr 3fr 1fr;
	color: $gray-600;

	&.productOptionRowSingle {
		grid-template-columns: 4fr 1fr;
	}

	.productOption {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 15px;

		&:first-child {
			padding-right: 18px;
		}

		&:last-child {
			justify-content: flex-end;
		}

		.unit {
			font-weight: 500;
		}

		.productBadges {
			flex-shrink: 0;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 18px;
			height: 18px;
			border-radius: 3px;
			font-size: 11px;
			font-weight: 600;
			line-height: 1;
		}

		.badge_blue {
			background: #dbeafe;
			color: #1d4ed8;
		}

		.badge_green {
			background: #dcfce7;
			color: #15803d;
		}
	}

	&.activeIngredients {
		.ingredientText {
			padding: 2px 6px;
			background: #f3f4f6;
			border-radius: 3px;
			font-size: 12px;
			color: #6b7280;
			cursor: default;
			white-space: nowrap;

			&[title]:not([title=""]) {
				cursor: help;
			}
		}
	}
}
